import './StateLabel-cd27f475.css';

var classes = {"Icon":"prc-StateLabel-Icon-NuDm4"};

export { classes as default };
